export default __webpack_public_path__ + "static/media/gear-reducer.bab08b6c.jpg";